import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { user } from '@stateApp'
import { createQuery } from '@tanstack/solid-query'
import { Show } from 'solid-js'
import { client } from '../utils/api-client'

export const PaymentsPortalButton = () => {
  const portalQuery = createQuery(() => ({
    queryKey: ['payments-portal-link'],
    queryFn: async () => client.getPaymentsLink(),
    enabled: !!user()?.access_token,
  }))

  return (
    <Show
      when={!portalQuery.isError}
      fallback={<Button disabled>Error loading portal</Button>}
    >
      <Button
        as="a"
        href={portalQuery.data?.url}
        disabled={portalQuery.isLoading}
        colorPalette="jade"
        variant="solid"
        rel="noopener noreferrer"
        w="full"
        mt={4}
      >
        <Show when={portalQuery.isLoading} fallback="Manage Subscription">
          <Spinner
            size="sm"
            mr={2}
          />
          Loading...
        </Show>
      </Button>
    </Show>
  )
}
